import React from 'react'
import { Box, Button, Modal, Typography, Checkbox } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { mainGreen, mainGrey } from '../utils/color'

export default function SelectTagModal({ open, onClose, tags, selectedTags, onTagsChange }) {
	return (
		<Modal open={open} onClose={onClose} sx={styles.modal}>
			<Box sx={styles.content}>
				<Box sx={styles.header}>
					<Box sx={styles.headerContent}>
						<Typography sx={styles.title}>Chọn Tags</Typography>
						<CloseIcon onClick={onClose} sx={styles.closeIcon} />
					</Box>
				</Box>

				<Box sx={styles.list}>
					{tags.map((tag) => (
						<Box key={tag.name} sx={styles.item}>
							<Checkbox
								checked={selectedTags.includes(tag.name)}
								onChange={(e) => {
									if (e.target.checked) {
										onTagsChange([...selectedTags, tag.name])
									} else {
										onTagsChange(selectedTags.filter((t) => t !== tag.name))
									}
								}}
							/>
							<Typography sx={{ color: tag.color || '#000' }}>{tag.name}</Typography>
						</Box>
					))}
				</Box>

				<Box sx={styles.footer}>
					<Button onClick={onClose} sx={styles.button}>
						Xong
					</Button>
				</Box>
			</Box>
		</Modal>
	)
}

const styles = {
	modal: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	content: {
		background: mainGrey,
		border: `2px solid ${mainGreen}`,
		borderRadius: '1rem',
		boxShadow: 'rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px',
		width: '100%',
		maxWidth: '400px',
		maxHeight: '50vh',
		position: 'relative',
		mx: 2,
	},
	header: {
		p: 2,
		borderBottom: '1px solid #e0e0e0',
		bgcolor: 'background.paper',
		borderTopLeftRadius: '16px',
		borderTopRightRadius: '16px',
	},
	headerContent: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
	},
	title: {
		fontSize: '1rem',
		fontWeight: 500,
	},
	closeIcon: {
		cursor: 'pointer',
		color: '#666',
	},
	list: {
		maxHeight: 'calc(50vh - 120px)',
		overflowY: 'auto',
		p: 2,
	},
	item: {
		display: 'flex',
		alignItems: 'center',
		py: 0.5,
	},
	footer: {
		p: 2,
		borderTop: '1px solid #e0e0e0',
		bgcolor: 'background.paper',
		borderBottomLeftRadius: '16px',
		borderBottomRightRadius: '16px',
		display: 'flex',
		justifyContent: 'flex-end',
	},
	button: {
		color: mainGreen,
		textTransform: 'none',
	},
}

